import OrderVpsHistoryModal from "./order-vps-history-modal.component";

export default OrderVpsHistoryModal;
